import { useStartedClientSession } from './useStartedClientSession';
import useTrackFirstFreemiumSession from './useTrackFirstFreemiumSession';

export const BootupEvents: React.FC<React.PropsWithChildren<unknown>> = () => {
  useTrackFirstFreemiumSession();
  useStartedClientSession();
  return null;
};
